/**
 * Shows offline/syncing status when user has pending changes or is offline.
 */
import React from "react";
import { useJournal } from "./JournalContext";
import { useTranslation } from "react-i18next";

export default function SyncStatus() {
  const { t } = useTranslation();
  const { isOnline, isSyncing, pendingCount } = useJournal();

  if (isOnline && !isSyncing && pendingCount === 0) return null;

  return (
    <div
      className="sync-status"
      role="status"
      aria-live="polite"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "0.75rem",
        padding: "4px 10px",
        borderRadius: "20px",
        background: isOnline
          ? "rgba(54, 119, 239, 0.15)"
          : "rgba(156, 163, 175, 0.2)",
        color: isOnline ? "var(--accent, #3677ef)" : "var(--text-muted, #6b7280)",
      }}
    >
      {isSyncing ? (
        <>
          <span className="material-symbols-outlined" style={{ fontSize: "14px", animation: "spin 1s linear infinite" }}>
            sync
          </span>
          <span>{t("syncing") || "Syncing..."}</span>
        </>
      ) : !isOnline ? (
        <>
          <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>
            cloud_off
          </span>
          <span>{t("offline") || "Offline"}</span>
          {pendingCount > 0 && (
            <span style={{ opacity: 0.8 }}>
              ({pendingCount} {t("pending") || "pending"})
            </span>
          )}
        </>
      ) : null}
    </div>
  );
}
